import script from "./FieldsSortBy.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldsSortBy.vue?vue&type=script&setup=true&lang=js"

import "./FieldsSortBy.vue?vue&type=style&index=0&id=1e242e28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e242e28"]])

export default __exports__